import React, { useCallback } from 'react';
import { ItemCreationPicker } from '~/Components/ItemCreation/ItemCreationPicker';
import { EventType } from '~/Models/DTO/Event.model';
import { useEventTypePickerListItems } from './useEventTypePickerListItems';
import { GRAY_DARK_SHADE_1, WHITE } from '~/Constants/Colors.constants';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useTranslation } from 'react-i18next';
import { Theme, useMediaQuery } from '@mui/material';
import { useNavigation } from '~/Hooks';
import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';
import { EventProductTour } from '~/Components';

export interface IEventTypePickerProps {
  selectEventType: (eventType: EventType) => void;
}

export const EventTypePicker = () => {
  const { t } = useTranslation();
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { navigate } = useNavigation();
  const onEventTypeClicked = useCallback(
    (eventType: EventType) => navigate(routeReplacer(Route.EVENT_TYPE_CREATE, { eventType })),
    [],
  );
  const listItems = useEventTypePickerListItems({ onEventTypeClicked });

  return (
    <PrivateLayout
      title={mobile ? undefined : t('event.createNew')}
      cancelInsteadOfBack
      backgroundColor={mobile ? GRAY_DARK_SHADE_1 : WHITE}
    >
      <ItemCreationPicker listItems={listItems} />
      <EventProductTour />
    </PrivateLayout>
  );
};
